import { SeatSide } from "./banker_bullbull_table_module";

import * as RoomProto from "../../net/proto/proto_bullbull_room";

const { ccclass ,property} = cc._decorator;

@ccclass
export default class BullBullPlayerInfo{
    
    private _playerId : number | Long;
    public  get playerId() : number | Long {
        return this._playerId;
    }    

    /**
     * 是否在打牌状态
     */
    private _isBattle : boolean;
    public get isBattle() : boolean {
        return this._isBattle;
    }
    public set isBattle(v : boolean) {
        this._isBattle = v;
    }
    
    
    private _seatSide : SeatSide;
    public get seatSide() : SeatSide {
        return this._seatSide;
    }
    public set seatSide(v : SeatSide) {
        this._seatSide = v;
    }

    
    private _isAvatar : boolean;
    public get isAvatar() : boolean {
        return this._isAvatar;
    }
    public set isAvatar(v : boolean) {
        this._isAvatar = v;
    }

    
    private _seatInfo : RoomProto.BullBullRoom.ISeatInfo;
    public get seatInfo() : RoomProto.BullBullRoom.ISeatInfo {
        return this._seatInfo;
    }
    public set seatInfo(v : RoomProto.BullBullRoom.ISeatInfo) {
        this._seatInfo = v;
    }
    
        
    constructor( id : number | Long , seatSide : number , seatInfo : RoomProto.BullBullRoom.ISeatInfo ){
        
        this._playerId = id;
        this._seatSide = seatSide;
        this._isAvatar = false;        

        this._seatInfo = new RoomProto.BullBullRoom.SeatInfo();
        Object.assign(this._seatInfo,seatInfo);
    }
}